import React from 'react';
import FeaturesSection from '../../YouTubeThumbnailHome/FeaturesSection';

const AllToolsList = () => {
  return (
    <>
      <FeaturesSection />
    </>
  );
};

export default AllToolsList;